export function scrollToTop(ofPage: boolean = false) {
    document.getElementById(ofPage ? 'anchor-page-top' : 'anchor-top')?.scrollIntoView();
}